import type { EndorsementUnderwritingFragment } from "@covertree/agent-portal-graphql";

import type { EndorsementData } from "./types";

/**
 * The UW part of `EndorsementData` from a `projectedPolicy`, shared by the draft
 * load and the save/reprice. `undefined` when there is no projection, so callers
 * can spread it over what they already hold.
 *
 * Only one unit exists today, matching the rest of the flow.
 */
export const projectUnderwriting = (
  projectedPolicy?: EndorsementUnderwritingFragment | null
):
  | Pick<EndorsementData, "underwritingQuestions" | "underwritingAnswers">
  | undefined =>
  projectedPolicy
    ? {
        underwritingQuestions: [
          ...projectedPolicy.policyLevelUnderwritingQuestions,
          ...projectedPolicy.units.flatMap(
            (unit) => unit.unitLevelUnderwritingQuestions
          ),
        ],
        underwritingAnswers: {
          policyLevel: projectedPolicy.policyLevelUnderwritingAnswers,
          unitLevel: projectedPolicy.units[0]?.unitLevelUnderwritingAnswers,
        },
      }
    : undefined;
